/**
 * 에이전트·서버·화면이 같이 쓰는 시간 상수.
 *
 * 조회 기간 상한은 서버(`APM_QUERY_MAX_RANGE_DAYS` 기본값)와 화면(보내기 전 검사)이 같아야
 * 한다. 어긋나면 화면은 통과시키고 서버가 400을 주거나, 반대로 화면이 먼저 막아 서버가 받을
 * 수 있는 조회를 못 하게 된다. 값을 여기 하나만 둔다 (13회차).
 */

export const HOUR_MS = 60 * 60_000;
export const DAY_MS = 24 * HOUR_MS;

/**
 * 한 번에 조회할 수 있는 최대 기간(일). 11회차에 콜드(Parquet)가 생겨 날짜당 파일이
 * 하나라 7 → 31로 늘렸다 (11회차 결정 2).
 */
export const MAX_RANGE_DAYS = 31;
